import React, { useState } from "react";
import "./RegalPageWrapper.scss"
import Navbar from "./components/Navbar/Navbar";
import Footer from "./components/Footer/Footer";
import LeftDrawer from "./components/LeftDrawer/LeftDrawer";

const RegalPageWrapper = ({ children }) => {
    const [isMenuOpen, setIsMenuOpen] = useState(false)

    return (
        <div className="RegalPageWrapper">
            <LeftDrawer
                isOpen={isMenuOpen}
                setIsOpen={setIsMenuOpen} />
            <Navbar
                setIsMenuOpen={setIsMenuOpen} />
            {children}
            <Footer />
        </div>
    )
}
export default RegalPageWrapper